import * as React from "react"
export const Svg_053 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <path fill="url(#a)" d="M3.398 3.572H22.09v5.762H3.398V3.572Z" />
    <path
      fill="url(#b)"
      d="M3.398 12.791v26.504h51.204V12.79H3.398Zm23.79 21.894H10.195V20.857h16.992v13.828Zm7.023 0h-3.398v-3.457h3.398v3.457Zm0-6.914h-3.398v-3.457h3.398v3.457Zm6.797 6.914h-3.399v-3.457h3.399v3.457Zm0-6.914h-3.399v-3.457h3.399v3.457Zm6.797 6.914h-3.399v-3.457h3.399v3.457Zm0-6.914h-3.399v-3.457h3.399v3.457Zm0-6.914H34.21V17.4h13.594v3.457Z"
    />
    <path fill="url(#c)" d="M17.224 50.818h23.552v4.61H17.224v-4.61Z" />
    <path
      fill="url(#d)"
      d="M0 55.428h13.825V47.36h30.35v8.067H58V42.752H0v12.676Z"
    />
    <path fill="url(#e)" d="M13.594 24.314h10.195v6.915H13.594v-6.915Z" />
    <defs>
      <linearGradient
        id="a"
        x1={7.721}
        x2={8.846}
        y1={4.437}
        y2={10.343}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={15.239}
        x2={23.408}
        y1={16.767}
        y2={42.308}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={22.67}
        x2={23.254}
        y1={51.51}
        y2={56.336}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.412}
        x2={15.198}
        y1={44.653}
        y2={57.877}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={15.951}
        x2={18.569}
        y1={25.352}
        y2={31.599}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)